import React from 'react';
import { WORK_REGIONS } from '../data/siteData';
import { useFormModal } from '../context/FormModalContext';

const AboutPage = () => {
    const { openForm } = useFormModal();

    return (
        <div className="page">
            <div className="container page-container">
                <h1 className="page-title">О компании</h1>

                <div className="page-content">
                    <p>
                        Мы оказываем информационные услуги по подбору персонала для организаций,
                        осуществляющих деятельность в сфере охраны: сопровождение грузов,
                        охрана складских комплексов, патрулирование местности и охрана мостов.
                    </p>
                    <p>
                        Мы помогаем соискателям найти вакансии охраны с вахтовым методом работы в регионах:{' '}
                        {WORK_REGIONS.join(', ')}.
                    </p>

                    <h2>Чем мы занимаемся</h2>
                    <ul>
                        <li>консультации по вакансиям и условиям трудоустройства;</li>
                        <li>приём заявок от соискателей;</li>
                        <li>передача контактных данных партнёрам-работодателям для обратной связи.</li>
                    </ul>

                    <h2>Преимущества для соискателей</h2>
                    <ul>
                        <li>бесплатная подача заявки и консультация;</li>
                        <li>информация об условиях до принятия решения о трудоустройстве;</li>
                        <li>сопровождение на этапе подачи документов.</li>
                    </ul>

                    <h2>Как мы работаем</h2>
                    <ol className="steps-list">
                        <li>
                            <strong>Заявка</strong> — вы оставляете контактные данные на сайте.
                        </li>
                        <li>
                            <strong>Звонок</strong> — специалист связывается с вами и уточняет детали.
                        </li>
                        <li>
                            <strong>Консультация</strong> — рассказываем об условиях, вакансиях и регионах.
                        </li>
                        <li>
                            <strong>Трудоустройство</strong> — при согласии направляем к работодателю-партнёру.
                        </li>
                    </ol>

                    <button type="button" className="cta-button" onClick={openForm}>
                        Оставить заявку
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;
